import React, { Component } from 'react';
import './App.css';

class PrivacyPage extends Component {

    constructor(props){
        super()
    }

    render() {
        return (
            <div className="privacy-policy-page">
                <div className={"policy-block"}>
                <h1>Privacy Policy</h1>
                <h2>Crouton</h2>
                <p>Devin built the Crouton app as a paid app. This SERVICE is provided by Devin and is intended for use as is.

                This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.

                If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.

                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Crouton unless otherwise defined in this Privacy Policy.

                <h4>Information Accessed and Use of TrueDepth API</h4>
                When you use the Hands free navigation feature feature on Crouton, we use Apple’s TrueDepth API to read facial expressions in order to determine whether or not to trigger the action for swiping left and right (That is, we check if the user’s winking with their left or right eye or not, or opening their mouth).
                The entire processing for the hands free navigation feature is done on device and in real time. The TrueDepth data never leaves the device, is never stored on the device or stored on our server or shared with any other third party, or for any other purpose other than setting up and using hands free navigation.
                Furthermore, it’s an Opt-in feature, that works only with your explicit permission to use the front facing camera.

                <h4>How do we use your personal information</h4>
                We make use of the TrueDepth API to read facial expressions in order to determine whether or not a user is winking or opening their mouth.
                This information is not recorded for any further use. It is not stored for any future use. It is not shared with any third party services. And it is always processed on device

                <h4>Information Collection and Use</h4>

                For a better experience, while using our Service, I may require you to provide us with certain personally identifiable information. The information that I request will be retained on your device and is not collected by me in any way.

                The app does use third party services that may collect information used to identify you.
                </p>

                <h4>Log Data</h4>

                I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.

                <h4>Cookies</h4>

                Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device’s internal memory.

                This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.

                <h4>Children’s Privacy</h4>

                These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13. In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.
                
                <h4>Security</h4>

                I value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and I cannot guarantee its absolute security.

                Links to Other Sites

                This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by me. Therefore, I strongly advise you to review the Privacy Policy of these websites. I have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.

                Children’s Privacy/h4>

                These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13. In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.

                <h4>Changes to This Privacy Policy</h4>

                I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.

                <h4>Contact Us</h4>

                If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me at justmedevin@gmail.com

                <h1>Daily</h1>
                Devin Davies built the Daily app as a Free app. This SERVICE is provided by Devin Davies at no cost and is intended for use as is.

                This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.

                If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.

                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Daily unless otherwise defined in this Privacy Policy.

                <h4>Information Collection and Use</h4>

                For a better experience, while using our Service, I may require you to provide us with certain personally identifiable information. The information that I request will be retained on your device and is not collected by me in any way.

                The app does use third party services that may collect information used to identify you.

                Firebase
                Log Data

                I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.

                <h4>Security</h4>

                I value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and I cannot guarantee its absolute security.

                <h4>Children’s Privacy</h4>

                These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13. In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.

                <h4>Changes to This Privacy Policy</h4>

                I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.

                <h4>Contact Us</h4>

                If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me justmedevin@gmail.com.

                <h1>Planner</h1>
                Devin Davies built the Planner app as a Free app. This SERVICE is provided by Devin Davies at no cost and is intended for use as is.

                This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.

                If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.

                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Planner unless otherwise defined in this Privacy Policy.

                <h4>Information Collection and Use</h4>

                For a better experience, while using our Service, I may require you to provide us with certain personally identifiable information, including but not limited to email address, name.

                The app does use third party services that may collect information used to identify you.

                Link to privacy policy of third party service providers used by the app

                Firebase
                Log Data

                I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.

                <h4>Security</h4>

                I value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and I cannot guarantee its absolute security.

                <h4>Children’s Privacy</h4>

                These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13. In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.

                <h4>Changes to This Privacy Policy</h4>

                I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.

                <h4>Contact Us</h4>

                If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me justmedevin@gmail.com

                <h1>TickTot</h1>
                Devin built the TickTot app as a paid app. This SERVICE is provided by Devin and is intended for use as is.

                This page is used to inform visitors regarding my policies with the collection, use, and disclosure of Personal Information if anyone decided to use my Service.

                If you choose to use my Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that I collect is used for providing and improving the Service. I will not use or share your information with anyone except as described in this Privacy Policy.

                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Planner unless otherwise defined in this Privacy Policy.

                <h4>Information Collection and Use</h4>

                For a better experience, while using our Service, I may require you to provide us with certain personally identifiable information, including but not limited to email address, name.

                The app does use third party services that may collect information used to identify you.

                Link to privacy policy of third party service providers used by the app

                Firebase
                Log Data

                I want to inform you that whenever you use my Service, in a case of an error in the app I collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing my Service, the time and date of your use of the Service, and other statistics.

                <h4>Security</h4>

                I value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and I cannot guarantee its absolute security.

                <h4>Children’s Privacy</h4>

                These Services do not address anyone under the age of 13. I do not knowingly collect personally identifiable information from children under 13. In the case I discover that a child under 13 has provided me with personal information, I immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact me so that I will be able to do necessary actions.

                <h4>Changes to This Privacy Policy</h4>

                I may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. I will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.

                <h4>Contact Us</h4>

                If you have any questions or suggestions about my Privacy Policy, do not hesitate to contact me justmedevin@gmail.com
                </div>

                
            </div>
        );
    }
}

PrivacyPage.propTypes = {

};


export default PrivacyPage;


// WEBPACK FOOTER //
// ./src/PrivacyPage.js